<div class="login-card">
  <div class="country-div">
    <span class="form-label">Country/Region</span>
    <app-phil-dropdown placeholder="(Select Country/Region)" [options]="countryList" [isSelectEmit]="true"
      (optionSelected)="countrySelected.emit($event)" [control]="selectedCountry"></app-phil-dropdown>
  </div>

  <form [formGroup]="form" style="display: flex; flex-direction: column; gap: 24px" (ngSubmit)="onFormSubmit()">
    <div class="form-group">
      <label for="contact">{{ contactLabel }}</label>
      <app-phil-input [control]="contactControl" [placeholder]="contactPlaceholder"
        [type]="contactInputType"></app-phil-input>
      @if (displayError) {
      <small class="error-text">{{ displayError }}</small>
      }
    </div>

    <button type="submit" class="login-btn" [disabled]="isLoading || isLocating || buttonDisabled">
      @if (isLoading || isLocating) {
      <span class="spinner" role="status" aria-label="Loading"></span>
      } @else {
      {{ buttonText }}
      }
    </button>
  </form>

</div>

<dialog #locationDialog class="location-dialog" aria-labelledby="location-popup-title"
  (click)="onDialogClick($event)" (cancel)="onDialogCancel($event)" (close)="onDialogClosed()">
  <div class="location-popup">
    <div class="location-pin">
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
        stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M12 21s-7-5.1-7-11a7 7 0 0 1 14 0c0 5.9-7 11-7 11z" />
        <circle cx="12" cy="10" r="2.6" />
      </svg>
    </div>

    <span id="location-popup-title" class="location-popup-title">Turn on location to continue</span>

    @if (locationIssue === 'prime') {
    <p class="location-popup-text">
      For your safety, we check your location while logging in. Press <b>Continue</b>, then choose
      <b>Allow</b> when your phone asks.
    </p>
    }
    @if (locationIssue === 'generic') {
    <p class="location-popup-text">
      We could not get your location. Please make sure location is switched on, then try again.
    </p>
    }
    @if (locationIssue === 'blocked') {
    <p class="location-popup-text">Location is blocked for this website. It only takes a moment to allow it:</p>
    <div class="location-steps">
      <span class="location-step">
        <span class="step-num">1</span>
        <span>Tap the <b>lock</b> icon at the top, next to the website address</span>
      </span>
      <span class="location-step">
        <span class="step-num">2</span>
        <span>Tap <b>Permissions</b> or <b>Site settings</b>, then set <b>Location</b> to <b>Allow</b></span>
      </span>
      <span class="location-step">
        <span class="step-num">3</span>
        <span>Come back here and press the button below</span>
      </span>
    </div>
    }
    @if (locationIssue === 'deviceOff') {
    <p class="location-popup-text">Your phone's location (GPS) seems to be switched off:</p>
    <div class="location-steps">
      <span class="location-step">
        <span class="step-num">1</span>
        <span>Open your phone's <b>Settings</b></span>
      </span>
      <span class="location-step">
        <span class="step-num">2</span>
        <span>Tap <b>Location</b> and switch it <b>On</b></span>
      </span>
      <span class="location-step">
        <span class="step-num">3</span>
        <span>Come back here and press the button below</span>
      </span>
    </div>
    }

    <button type="button" class="location-btn" (click)="requestLocation()" [disabled]="isLocating">
      @if (isLocating) {
      <span class="spinner" role="status" aria-label="Checking location"></span>
      } @else {
      {{ primaryButtonLabel }}
      }
    </button>
    <button type="button" class="location-later" (click)="closeLocationPopup()">Not now</button>
  </div>
</dialog>